const theftsPerLocationData = [
  {
    location: 'RSF', count: 121,
  },
  {
    location: 'Moffitt Library	', count: 94,
  },
  {
    location: 'Evans Hall', count: 76,
  },
  {
    location: 'Dwinelle Hall', count: 60,
  },
  {
    location: 'Unit 2', count: 40,
  },
];

export default theftsPerLocationData;
